import React from "react";

// Stylesheet
import "./AboutUse.css";

// Assets
import useWallet from "../../../assets/use-wallet.png";
import useImage from "../../../assets/use-image.png";
import useUsers from "../../../assets/use-users.png";

function AboutUse() {
  return (
    <section className="about-use-section">
      <div className="about-cards about-use-cards">
        <div className="about-title-with-card">
          <div className="about-title">For Creators</div>
          <div
            className="about-card about-use-card"
          >
            <img src={useWallet} alt="Wallet" />
            <div className="about-use-details">
              <p>
                NFT marketplaces have provided massive opportunities to millions of 
                artists for demonstrating their skills. However, these 
                marketplaces don’t provide a way to promote the artists’ NFTs. 
                LoopGem is the world’s first marketplace to fill this gap. 
                We help artists to connect with the influencers who can promote their NFTs.
              </p>
            </div>
          </div>
        </div>
        <div className="about-title-with-card about-title-with-card-reverse">
          <div className="about-card about-use-card">
            <img src={useImage} alt="Create" />
            <div className="about-use-details">
              <p>
                In the NFT ecosystem, influencers play a vital role by acting as a 
                bridge between artists and art collectors. Influencers help creators 
                promote their art to millions of people. Currently, influencers get a 
                lot of requests to promote NFTs and it becomes difficlit for them to 
                filter the ones that align with their mission. LoopGem has the vision 
                to save influencers’ precious time by filtering promotion requests for them.
                We will create a portal to get influencers’ preferences for the kind of art 
                they want to promote and then use those preferences to filter the promotion requests.
              </p>
            </div>
          </div>
          <div className="about-title">For Influencers</div>
        </div>
        <div className="about-title-with-card">
          <div className="about-title">For Collectors</div>
          <div className="about-card about-use-card">
            <img src={useUsers} alt="Promote" />
            <div className="about-use-details">
              <p>LoopGem allows collectors to discover the art of various artists 
              and collect ones that are true to their values. </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUse;
